// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"7197fe53","626":"4f612692"}[chunkId] + ".chunk.js";
};